import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useLanguage } from "../context/LanguageContext";
import { getRechartsTooltipProps } from "../theme";
import { consumptionPreviewRows } from "./config/consumptionPreview";

export default function ConsumptionPreview({ periods, demand }) {
  const { isGreek } = useLanguage();
  const theme = useTheme();
  const rows = consumptionPreviewRows(periods, demand.monthly);
  const entered = rows.filter((row) => row.value !== null);
  const total = entered.reduce((sum, row) => sum + row.value, 0);
  const format = (value) => Number(value).toLocaleString("en-GB", { maximumFractionDigits: 1 });
  const chart = (data, unit, name, category, labelFormatter) => (
    <Box sx={{ height: 220, minWidth: 0 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 22, right: 12, bottom: 8, left: 6 }} accessibilityLayer>
          <CartesianGrid stroke={theme.palette.divider} strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey={category} tick={{ fontSize: 11 }} interval="preserveStartEnd" />
          <YAxis tick={{ fontSize: 11 }} width={62} domain={[0, "auto"]}
            label={{ value: unit, position: "top", offset: 8 }} />
          <Tooltip {...getRechartsTooltipProps(theme.palette.mode)}
            formatter={(value) => [`${format(value)} ${unit}`, name]} labelFormatter={labelFormatter} />
          <Bar dataKey="value" name={name} fill={theme.palette.primary.main} maxBarSize={34} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
  return (
    <Box data-no-translate="" sx={{ minWidth: 0 }}>
      <Box sx={{ minWidth: 0, p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1.5 }}>
        <Typography variant="subtitle2">{isGreek ? "Κατανάλωση ανά περίοδο" : "Consumption by period"}</Typography>
        <Typography variant="caption" color="text.secondary">
          {entered.length === rows.length
            ? (isGreek ? "Ετήσια κατανάλωση: " : "Annual consumption: ")
            : (isGreek ? "Σύνολο συμπληρωμένων περιόδων: " : "Total for entered periods: ")}
          {format(total)} kWh
        </Typography>
        {entered.length ? chart(rows, "kWh", isGreek ? "Κατανάλωση" : "Consumption", "shortLabel",
          (label, payload) => payload?.[0]?.payload?.label || label) : (
          <Box sx={{ py: 1.5, display: "grid", placeItems: "center" }}>
            <Typography variant="body2" color="text.secondary">
              {isGreek ? "Συμπληρώστε τις kWh για να εμφανιστεί το διάγραμμα." : "Enter consumption in kWh to display the chart."}
            </Typography>
          </Box>
        )}
        <Typography variant="caption" color="text.secondary">
          {isGreek ? "Κάθε στήλη δείχνει το σύνολο της αντίστοιχης περιόδου. Τα κενά πεδία δεν θεωρούνται μηδενικά." : "Each bar is the total for its period. Empty fields are not treated as zero."}
        </Typography>
      </Box>
    </Box>
  );
}
